/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { useCioPlpContext } from '../../hooks/useCioPlpContext';
import { isHexColor } from '../../utils';
export default function ProductSwatch(props) {
    const context = useCioPlpContext();
    const { swatchObject, children } = props;
    const { swatchList, selectVariation, selectedVariation } = swatchObject;
    if (!context) {
        throw new Error('This component is meant to be used within the context of the CioPlpProvider');
    }
    const { callbacks: { onSwatchClick }, } = context;
    const swatchClickHandler = (e, clickedSwatch) => {
        selectVariation(clickedSwatch);
        if (onSwatchClick) {
            onSwatchClick(e, clickedSwatch);
        }
    };
    const swatchContainerClickHandler = (e) => {
        e.preventDefault();
    };
    return (React.createElement(React.Fragment, null, typeof children === 'function' ? (children({
        swatchList,
        selectVariation,
        selectedVariation,
    })) : (
    /* eslint-disable jsx-a11y/no-static-element-interactions */
    React.createElement("div", { onClick: swatchContainerClickHandler },
        React.createElement("ul", { className: 'cio-swatch-container' }, swatchList?.map((swatch) => {
            const isSelected = selectedVariation?.variationId === swatch.variationId;
            const color = isHexColor(swatch?.swatchPreview)
                ? swatch?.swatchPreview
                : `url(${swatch?.swatchPreview})`;
            return (React.createElement("button", { type: 'button', key: swatch.variationId, "data-cnstrc-variation-id": swatch.variationId, "data-testid": `cio-swatch-${swatch.variationId}`, className: 'cio-swatch-button cio-swatch-item', onClick: (e) => swatchClickHandler(e, swatch), style: {
                    background: color,
                } }, isSelected && (React.createElement("div", { "data-cnstrc-variation-id": swatch.variationId, className: 'cio-swatch-selected', style: { outline: `3px solid ${color}` } }))));
        }))))));
}
